import { StorageKey } from 'common/context/Storage'
import { env } from 'common/env'

export function callBackend(input: RequestInfo, init?: RequestInit): Promise<Response> {
  init = init || {}
  let headers = init.headers || {}

  if (init.body && !(init.headers && init.headers['Content-Type'])) {
    headers = {
      ...init.headers,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }
  }

  if (env.interfaceId) {
    headers = {
      ...init.headers,
      'interface-id': env.interfaceId,
    }
  }

  init = {
    ...init,
    credentials: 'include',
    headers: {
      ...headers,
    },
  }

  return fetch(input, init).then((resp: Response) => {
    if (resp.ok) {
      let tokenExpirationString = resp.headers.get('Token-Expiration')
      if (tokenExpirationString) {
        localStorage.setItem(
          StorageKey.TokenExpiration,
          `${(+(tokenExpirationString as string) || 120) * 1000 + Date.now()}`,
        )
      }
      return resp
    }
    console.error(resp)

    return Promise.reject(resp)
  })
}

export function processError(error: Response): Promise<any> {
  return Promise.reject(error)
}
